import { render, staticRenderFns } from "./cordx-tyfast-ovulation-test-pregnancy-test-combo.vue?vue&type=template&id=efa07d06&scoped=true&"
import script from "./cordx-tyfast-ovulation-test-pregnancy-test-combo.vue?vue&type=script&lang=js&"
export * from "./cordx-tyfast-ovulation-test-pregnancy-test-combo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa07d06",
  null
  
)

export default component.exports